import React from 'react';

import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import {
	LazySpaceReportsSiteSettings,
	ADMIN_SPACE_REPORT_SCREEN,
} from '@confluence/site-settings/entry-points/spaceReports.ts';

export const AdminSpaceReportsRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS(): {
		Screen: {
			screenEvent: {
				name: string;
			};
		};
		MainLayout: {
			navView: string;
		};
	};
} = (): React.JSX.Element => <LazySpaceReportsSiteSettings />;

AdminSpaceReportsRoute.NAVIGATION_PARAMS = (): {
	Screen: {
		screenEvent: {
			name: string;
		};
	};
	MainLayout: {
		navView: string;
	};
} => ({
	Screen: {
		screenEvent: { name: ADMIN_SPACE_REPORT_SCREEN },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
